// extracted by mini-css-extract-plugin
module.exports = {"fill-transition":"_Button_fill-transition_1diIa","outline-transition":"_Button_outline-transition_3opW4","link-transition":"_Button_link-transition_1qor6"};